import { UserRulesEffects } from '@appService/stores/user-rules/user-rules.effects'
import { ParamsConfigEffects } from '@appService/stores/params-config/params-config.effects'

export const effectsStore = [
  UserRulesEffects,
  ParamsConfigEffects
]
